import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LocalesService } from '../services/locales/locales.service';

@Component({
  selector: 'ama-login-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  standalone: false,
  styleUrls: ['cookie-policy.style.scss']
})
export class CookiePolicyComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  private readonly http = inject(HttpClient);
  private readonly localesService = inject(LocalesService);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly cdr = inject(ChangeDetectorRef);

  private static readonly urlPrefix = 'assets/legal/legalDocument_';
  private static readonly urlExt = '.html';
  public content: SafeHtml | undefined;
  private static readonly contentCache: Map<string, SafeHtml> = new Map<string, SafeHtml>();

  ngOnInit(): void {
    this.loadAndShowPolicies();
  }

  public scrollTo(id: string): void {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView();
    }
  }

  public loadAndShowPolicies() {
    const url = `${CookiePolicyComponent.urlPrefix}${this.localesService.getLanguageCode()}${
      CookiePolicyComponent.urlExt
    }`;
    this.http.get(url, { responseType: 'text' }).subscribe(
      (response) => {
        CookiePolicyComponent.contentCache.set(
          this.localesService.getLanguageCode(),
          this.domSanitizer.bypassSecurityTrustHtml(response)
        );
        this.content = CookiePolicyComponent.contentCache.get(this.localesService.getLanguageCode());
        this.cdr.detectChanges();
      },
      (error) => {
        throw new Error(`Error:${JSON.stringify(error)}:`);
      }
    );
  }
}
